import { DocType } from 'entities/Documents'

import { get, put } from './fetch'

export interface FieldRule {
  no: number
  order: number
  fieldName: string
  display: boolean
  edit: boolean
  verify: boolean
}
export interface OperationRule {
  ocrServiceID: number
  rules: FieldRule[]
}

export interface Rule {
  subGroup: string
  ocrBuilderConfigID: number
  documentType: DocType
  documentTypeName: string
  createTime: string
}

export interface ExportSettingsItem {
  documentType: DocType
  documentName: string
  subGroup: string
  ocrBuilderConfigID: number
  exportFormat: string
  csvByDocumentType?: boolean
}

export function getRuleList() {
  return get('operationRuleList') as Promise<Rule[]>
}

export async function getRuleSetting(
  subGroup: string,
  documentType: DocType,
  ocrBuilderConfigID: number,
) {
  return get('operationRuleSetting', {
    params: { subGroup, documentType, ocrBuilderConfigID },
  }) as Promise<OperationRule>
}

export interface SaveRuleSettingParams {
  subGroup: string
  ocrBuilderConfigID: number
  documentType: DocType
  documentTypeName: string
  mappings: FieldRule[]
}

export function saveRuleSetting(params: SaveRuleSettingParams) {
  return put('operationRuleSetting', { ...params })
}

export function getExportSettings() {
  return get('exportSettings') as Promise<ExportSettingsItem[]>
}

export function setCsvByDocumentType(
  ocrBuilderConfigId: number,
  csvByDocumentType: boolean,
) {
  return put(`exportSettings/template/${ocrBuilderConfigId}`, {
    csvByDocumentType,
  })
}
